import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { adminService } from '@services/adminService';
import { Megaphone, Send } from 'lucide-react';
import toast from 'react-hot-toast';

const AdminBroadcast = () => {
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [planFilter, setPlanFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');

  const broadcastMutation = useMutation({
    mutationFn: () =>
      adminService.sendBroadcast({
        subject,
        body,
        filter: {
          ...(planFilter && { plan: planFilter }),
          ...(statusFilter && { status: statusFilter }),
        },
      }),
    onSuccess: (res) => {
      const { sent, errors, total } = res;
      toast.success(`Enviado para ${sent}/${total} usuários${errors > 0 ? ` (${errors} erros)` : ''}`);
      setSubject('');
      setBody('');
    },
    onError: () => toast.error('Erro ao enviar broadcast'),
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!subject.trim() || !body.trim()) {
      toast.error('Preencha assunto e mensagem');
      return;
    }
    broadcastMutation.mutate();
  };

  return (
    <div className="max-w-2xl">
      <h1 className="text-white text-2xl font-bold mb-1">Broadcast</h1>
      <p className="text-gray-400 text-sm mb-6">Enviar e-mail para todos os usuários ou segmento</p>

      <div className="bg-gray-900 border border-gray-800 rounded-xl p-6">
        <div className="flex items-center gap-2 mb-6">
          <Megaphone className="h-5 w-5 text-indigo-400" />
          <h2 className="text-white font-semibold">Nova mensagem</h2>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Filters */}
          <div className="grid grid-cols-2 gap-3 p-4 bg-gray-800/50 rounded-lg">
            <div>
              <label className="block text-gray-400 text-xs mb-1">Filtrar por plano</label>
              <select
                value={planFilter}
                onChange={(e) => setPlanFilter(e.target.value)}
                className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-sm text-gray-300 focus:outline-none focus:border-indigo-500"
              >
                <option value="">Todos os planos</option>
                <option value="free">Free</option>
                <option value="pro">Pro</option>
                <option value="family">Family</option>
              </select>
            </div>
            <div>
              <label className="block text-gray-400 text-xs mb-1">Filtrar por status</label>
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-sm text-gray-300 focus:outline-none focus:border-indigo-500"
              >
                <option value="">Todos os status</option>
                <option value="active">Ativo</option>
                <option value="trial">Trial</option>
                <option value="suspended">Suspenso</option>
              </select>
            </div>
          </div>

          <div>
            <label className="block text-gray-400 text-xs mb-1">Assunto</label>
            <input
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Assunto do e-mail"
              className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-sm text-gray-200 placeholder-gray-500 focus:outline-none focus:border-indigo-500"
            />
          </div>

          <div>
            <label className="block text-gray-400 text-xs mb-1">Mensagem</label>
            <textarea
              value={body}
              onChange={(e) => setBody(e.target.value)}
              placeholder="Corpo do e-mail (texto simples)"
              rows={8}
              className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-sm text-gray-200 placeholder-gray-500 focus:outline-none focus:border-indigo-500 resize-y"
            />
          </div>

          <button
            type="submit"
            disabled={broadcastMutation.isPending}
            className="flex items-center gap-2 px-5 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-medium disabled:opacity-50 transition-colors"
          >
            <Send className="h-4 w-4" />
            {broadcastMutation.isPending ? 'Enviando...' : 'Enviar broadcast'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminBroadcast;
